// src/context/ProtectedRoute.jsx
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function decodeJwt(token) {
  try {
    if (!token || token.split(".").length !== 3) return null;
    let payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    while (payload.length % 4) payload += "=";
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
}

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, token, loading = false } = useAuth();
  const location = useLocation();
  const routeUser = user || decodeJwt(token);

  if (loading) return null; // or a spinner

  const isAuthed = Boolean(token ?? routeUser);
  if (!isAuthed) {
    // not logged in -> go to login and remember the original dest
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // if roles are specified, enforce them
  if (allowedRoles && !allowedRoles.includes(routeUser?.role)) {
    // logged in but not allowed -> send to home (or a dedicated /unauthorized if you have one)
    return <Navigate to="/" replace />;
  }

  return children;
}
